import React from 'react';
import { Box, SxProps, Typography } from '@mui/material';
import { headingFontBold, vars } from '../../../../Theme';

type SeparatorType = 'dash' | 'colon';

const separators: Record<SeparatorType, string> = {
    dash: ' -',
    colon: ':',
};

const labelSx: SxProps = {
    ...headingFontBold,
    color: vars.font,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontSize: '16px',
    fontWeight: 700,
    lineHeight: 'normal',
    pr: '4px',
};

const valueSx: SxProps = {
    ...headingFontBold,
    color: vars.font,
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: 'normal',
};

export default ({
    label,
    value,
    separator = 'dash',
    boxSx,
}: {
    label: string;
    value: string;
    separator?: SeparatorType;
    boxSx?: SxProps;
}) => (
    <Box
        sx={{
            display: 'flex',
            border: `1px solid ${vars.lightGray}`,
            borderRadius: '4px',
            padding: '8px 12px',
            ...boxSx,
        }}
    >
        <Typography sx={labelSx}>
            {label}
            {separators[separator]}
        </Typography>
        <Typography sx={valueSx}>{value}</Typography>
    </Box>
);
